export const StorageHelper = {
  set: (key, value) => {
    try {
      // If value is already a string, store directly
      if (typeof value === "string") {
        localStorage.setItem(key, value);
      } else {
        // For objects/arrays, stringify
        const stringValue = JSON.stringify(value);
        localStorage.setItem(key, stringValue);
      }
    } catch (e) {
      console.error("Error saving to localStorage:", e);
    }
  },

  get: (key) => {
    try {
      const item = localStorage.getItem(key);
      if (!item) return null;

      // Try parsing as JSON, if fails return the raw string
      try {
        return JSON.parse(item);
      } catch (e) {
        // If parsing fails, it's probably a token or simple string
        return item;
      }
    } catch (e) {
      console.error("Error reading from localStorage:", e);
      return null;
    }
  },

  remove: (key) => {
    try {
      localStorage.removeItem(key);
    } catch (e) {
      console.error("Error removing from localStorage:", e);
    }
  },

  clear: () => {
    try {
      localStorage.clear();
    } catch (e) {
      console.error("Error clearing localStorage:", e);
    }
  },

  // Helper to check if value is JSON-parseable
  isJSON: (str) => {
    try {
      JSON.parse(str);
      return true;
    } catch (e) {
      return false;
    }
  },

  // Sheet-specific storage helpers
  sheets: {
    save: (sheetsData) => StorageHelper.set('excelSheets', sheetsData),
    load: () => StorageHelper.get('excelSheets'),
    clear: () => StorageHelper.remove('excelSheets'),
  },

  activeSheet: {
    save: (index) => StorageHelper.set('activeSheetIndex', index),
    load: () => StorageHelper.get('activeSheetIndex'),
    clear: () => StorageHelper.remove('activeSheetIndex'),
  },

  // Clear all sheet-related data
  clearSheets: () => {
    StorageHelper.remove('excelSheets');
    StorageHelper.remove('activeSheetIndex');
  },
};
